import { useEffect } from "react";
import "./kakao_map.css";
import marker_icon from "../../img/marker.png";

declare global {
  interface Window {
    kakao: any;
  }
}

function KakaoMap() {
  useEffect(() => {
    try {
      const container = document.getElementById("kakao_map");
      const options = {
        center: new window.kakao.maps.LatLng(36.7915, 127.1162),
        level: 4,
      };

      const imageSize = new window.kakao.maps.Size(64, 69);
      const imageOption = { offset: new window.kakao.maps.Point(27, 69) };
      const map = new window.kakao.maps.Map(container, options);

      const markerImage = new window.kakao.maps.MarkerImage(
        marker_icon,
        imageSize,
        imageOption
      );
      const markerPosition = new window.kakao.maps.LatLng(36.7915, 127.1162);

      const marker = new window.kakao.maps.Marker({
        position: markerPosition,
        image: markerImage, // 마커이미지 설정
      });

      // 마커가 지도 위에 표시되도록 설정합니다
      marker.setMap(map);

      const content = `<div class="customoverlay">
        <a href="http://kko.to/9g2RojTNt5" target="_blank">
          <span class="title">시니어사랑 방문요양센터</span>
        </a>
      </div>`;

      // 커스텀 오버레이가 표시될 위치입니다
      const position = new window.kakao.maps.LatLng(36.7915, 127.1162);

      // 커스텀 오버레이를 생성합니다
      const customOverlay = new window.kakao.maps.CustomOverlay({
        map: map,
        position: position,
        content: content,
        yAnchor: 3.5,
      });
    } catch (error) {
      console.error("Error rendering KakaoMap:", error);
    }
  }, []);

  return <div id="kakao_map"></div>;
}

export default KakaoMap;
